import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import useMediaQuery from '@src/hooks/useMediaQuery';

import Reviews from './reviews';
import WhatWillLearn from './whatWillLearn';
import CourseIntroduction from './courseIntroduction';
import PreparationBeforeCourse from './preparationBeforeCourse';
import FrequentlyAskedQuestion from './frequentlyAskedQuestion';
import CourseOutline from './courseOutline';
import TeacherIntroduction from './teacherIntroduction';
import Discussions from './discussions';
import RecommendedPlanCards from './recommendedPlanCards';

const HEIGHT_NAVIGATION = 58;
const PADDING_BOTTOM = 149;

const AdvancedInfoWrapper = styled.div`
	background: #FFFFFF;

	display: grid;
	grid-template-columns: 1fr 340px;

	@media ${props => props.theme.device.tablet} {
		margin-bottom: 103px;
	}

	@media ${props => props.theme.device.tablet} {
		grid-template-columns: 1fr 256px;
	}

	@media
		${props => props.theme.device.smTablet},
		${props => props.theme.device.mobile}
	{
		margin-bottom: 83px;
		grid-template-columns: 1fr;

		.advance-info__recommended-plan {
			display: none;
		}
	}
`;

const AdvancedInfo = (): JSX.Element => {
	const { mediaMatch: {
		isMobile, isSmTablet, isTablet,
	} } = useMediaQuery();
	const navRef = useRef(null);
	const [isFixed, setIsFixed] = useState(false);
	const [bottomOffset, setBottomOffset] = useState(0);
	const handleOnScroll = () => {
		if (isMobile || isSmTablet) return;
		const navElement = navRef.current;
		setIsFixed(window.pageYOffset >= (navElement.offsetTop - HEIGHT_NAVIGATION));

		const scrollHeight = document.body?.offsetHeight - window.innerHeight;
		setBottomOffset(scrollHeight - window.pageYOffset - PADDING_BOTTOM);
	};

	useEffect(() => {
		const footerElem = document.getElementById('footer');
		if (footerElem) {
			if (isMobile || isSmTablet || isTablet) {
				footerElem.style.display = 'none';
			} else {
				footerElem.style.display = 'block';
			}
		}
	}, [isMobile, isSmTablet, isTablet]);

	useEffect(() => {
		const scrollHeight = document.body?.offsetHeight - window.innerHeight;
		setBottomOffset(scrollHeight - window.pageYOffset - PADDING_BOTTOM);

		document.addEventListener('scroll', handleOnScroll);

		return () => {
			document.removeEventListener('scroll', handleOnScroll);
		};
	}, []);

	return (
		<AdvancedInfoWrapper>
			<div>
				<WhatWillLearn />
				<Reviews />
				<CourseIntroduction />
				<CourseOutline />
				<PreparationBeforeCourse />
				<FrequentlyAskedQuestion />
				<TeacherIntroduction />
				<Discussions />
			</div>
			<div
				ref={navRef}
				className="advance-info__recommended-plan"
			>
				<RecommendedPlanCards isFixed={isFixed} bottomOffset={bottomOffset} />
			</div>
		</AdvancedInfoWrapper>
	);
};

export default AdvancedInfo;
